function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M171.5 342C77.7163 342 1 265.266 1 171.5C1 77.7163 77.7337 1 171.5 1C265.284 1 342 77.7337 342 171.5C342.017 265.266 265.284 342 171.5 342Z",
  stroke: "url(#paint0_linear)",
  strokeMiterlimit: 10
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M213.698 133.778C214.308 131.775 214.918 129.807 215.527 127.839C214.761 130.085 213.994 132.332 213.246 134.579C213.385 134.335 213.542 134.056 213.698 133.778Z",
  fill: "url(#paint1_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M216.903 91.3877C216.903 91.3877 216.851 91.6315 216.764 92.0669C216.782 91.9798 216.816 91.8753 216.869 91.7186C216.886 91.5967 216.886 91.4922 216.903 91.3877Z",
  fill: "url(#paint2_linear)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M216.903 91.3877C216.903 91.3877 216.851 91.6315 216.764 92.0669C216.782 91.9798 216.816 91.8753 216.869 91.7186C216.886 91.5967 216.886 91.4922 216.903 91.3877Z",
  fill: "url(#paint3_linear)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M224.2 194.384C222.232 176.481 227.544 158.56 234.458 141.928C241.354 125.296 249.923 109.274 254.939 91.9798C255.896 88.6708 256.732 85.1005 255.635 81.8264C255.548 81.5651 255.444 81.3213 255.339 81.0775C253.981 78.1691 250.567 76.0444 247.641 77.2809C245.743 78.082 244.594 79.9803 243.566 81.7741C233.604 99.1202 223.66 116.449 213.698 133.795C191.267 208.073 173.886 308.631 173.886 308.631L227.648 216.816C227.648 216.816 225.018 201.908 224.2 194.384Z",
  fill: "url(#paint4_linear)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M172.022 115.09C171.813 115.787 171.587 116.484 171.378 117.18C171.952 91.0219 172.51 64.8635 173.084 38.6877C173.224 32.5573 171.482 24.3197 165.352 24.1455C160.075 24.0062 157.341 30.3107 156.33 35.4832C152.36 55.6854 152.795 76.4972 150.165 96.9259C147.536 117.355 141.301 138.34 126.637 152.796C125.87 153.544 124.965 154.346 123.885 154.293C121.812 154.224 121.168 151.489 121.116 149.417C120.837 139.681 119.984 129.633 115.403 121.029C111.798 114.255 104.989 107.95 97.1518 106.801C86.1102 105.181 96.3333 122.074 97.622 127.072C100.008 136.303 98.7715 146.073 100.078 155.512C101.732 167.616 107.462 178.745 111.485 190.274C115.282 201.159 122.422 220.16 122.422 220.16C122.422 220.16 150.357 268.593 173.92 308.614C173.92 308.614 173.955 307.796 174.025 306.28L171.5 117.18L172.022 115.09Z",
  fill: "url(#paint5_linear)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M194.349 124.652C200.375 100.444 206.419 76.2185 212.444 52.0106C213.907 46.1067 215.405 40.0808 214.883 34.0028C214.587 30.5022 213.298 26.6707 210.145 25.1556C206.976 23.6404 203.022 25.173 200.671 27.8028C198.32 30.4325 197.223 33.8983 196.178 37.2595C188.115 63.2089 180.069 89.1584 172.005 115.09L171.5 117.18L173.99 306.298C174.757 290.136 179.894 192.747 195.899 120.785C195.377 122.074 194.872 123.363 194.349 124.652Z",
  fill: "url(#paint6_linear)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M227.718 46.0892C228.241 45.6887 228.728 45.3055 229.233 44.9224C228.711 45.2707 228.206 45.6538 227.718 46.0892Z",
  fill: "url(#paint7_linear)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M216.903 91.3877C216.903 91.3877 216.851 91.6315 216.764 92.0669C216.782 91.9798 216.816 91.8753 216.869 91.7186C216.886 91.5967 216.886 91.4922 216.903 91.3877Z",
  fill: "url(#paint8_linear)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M213.228 134.596C213.994 132.349 214.76 130.103 215.509 127.856C218.296 118.905 221.169 110.388 224.078 102.569C228.728 88.8798 233.36 75.191 238.01 61.5197C239.108 58.2978 240.205 54.9714 239.891 51.5927C239.578 48.2141 237.436 44.7657 234.109 44.0343C232.316 43.6337 230.678 44.0517 229.233 44.9399C228.728 45.323 228.24 45.6888 227.718 46.1067C225.436 48.2141 223.695 51.4708 222.528 54.3966C213.646 76.532 204.781 98.6674 195.899 120.803C178.396 199.505 173.886 308.649 173.886 308.649C173.886 308.649 191.249 208.09 213.698 133.812C213.541 134.056 213.385 134.335 213.228 134.596ZM216.903 91.3876C216.885 91.4921 216.885 91.5966 216.868 91.7185C216.816 91.8579 216.781 91.9798 216.763 92.0669C216.85 91.6315 216.903 91.3876 216.903 91.3876Z",
  fill: "url(#paint9_linear)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M171.151 222.11C192.937 222.11 210.598 204.449 210.598 182.663C210.598 160.878 192.937 143.217 171.151 143.217C149.365 143.217 131.705 160.878 131.705 182.663C131.705 204.449 149.365 222.11 171.151 222.11Z",
  fill: "white"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M171.151 338.238C262.997 338.238 337.454 263.782 337.454 171.935C337.454 80.0889 262.997 5.63257 171.151 5.63257C79.3045 5.63257 4.84814 80.0889 4.84814 171.935C4.84814 263.782 79.3045 338.238 171.151 338.238Z",
  stroke: "url(#paint10_linear)",
  strokeWidth: 4,
  strokeMiterlimit: 10
});

var _ref14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 0.129213,
  y1: 171.49,
  x2: 342.885,
  y2: 171.49,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFDA13"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5279,
  stopColor: "#F18009"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D4070F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 213.256,
  y1: 130.109,
  x2: 215.485,
  y2: 132.338,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFDA13"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5279,
  stopColor: "#F18009"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D4070F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: -29.2729,
  y1: -154.406,
  x2: 294.407,
  y2: 169.244,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFDA13"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5279,
  stopColor: "#F18009"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D4070F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 216.703,
  y1: 91.5934,
  x2: 216.97,
  y2: 91.8609,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFDA13"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5279,
  stopColor: "#F18009"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D4070F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 172.215,
  y1: 152.135,
  x2: 251.296,
  y2: 231.216,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFDA13"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5279,
  stopColor: "#F18009"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D4070F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: 95.5778,
  y1: 91.174,
  x2: 391.738,
  y2: 387.334,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFDA13"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5279,
  stopColor: "#F18009"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D4070F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear",
  x1: 127.532,
  y1: 100.927,
  x2: 253.446,
  y2: 226.84,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFDA13"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5279,
  stopColor: "#F18009"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D4070F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear",
  x1: 212.647,
  y1: 29.6883,
  x2: 231.687,
  y2: 48.728,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFDA13"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5279,
  stopColor: "#F18009"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D4070F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear",
  x1: 216.703,
  y1: 91.5934,
  x2: 216.97,
  y2: 91.8609,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFDA13"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5279,
  stopColor: "#F18009"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D4070F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear",
  x1: 151.084,
  y1: 122.719,
  x2: 255.439,
  y2: 227.073,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFDA13"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5279,
  stopColor: "#F18009"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D4070F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint10_linear",
  x1: 1.36778,
  y1: 171.927,
  x2: 340.936,
  y2: 171.927,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFDA13"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5279,
  stopColor: "#F18009"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D4070F"
})));

function SvgLogoWithCircleBorder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 343,
    viewBox: "0 0 343 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWithCircleBorder);
export default __webpack_public_path__ + "static/media/logo-with-circle-border.4ade1c7b.svg";
export { ForwardRef as ReactComponent };